module.exports = __webpack_public_path__ + "assets/elsa-logo.a8b8af5f.svg";